<template>
  <div class="project-activities-root">
    <el-row>
      <el-col>
        <el-form :inline="true">
          <el-form-item size="large" label="状态:">
            <el-select v-model="selectedStatus" @change="getActivityList(true)">
              <el-option
                v-for="k in options"
                :label="statusCNEnum[k]"
                :value="k"
                :key="k"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row :gutter="20" v-loading="isLoading" class="container">
      <el-col
        v-for="activity in activities"
        :key="activity.activityid"
        :span="8"
        :xl="6"
      >
        <el-card
          class="activity-card"
          shadow="hover"
          :body-style="{ padding: '0px' }"
        >
          <div class="content">
            <div class="activity-title">{{ activity.activityname }}</div>
            <div
              class="activity-status"
              :class="statusClassEnum[activity.status]"
            >
              {{ statusCNEnum[activity.status] }}
            </div>
            <el-form label-width="80px">
              <el-form-item label="活动类型:">
                <div class="activity-category line">
                  {{ activity.category }}
                </div>
              </el-form-item>
              <el-form-item label="负责人:">
                <div class="activity-creator line">
                  {{ activity.creator.email }}
                </div>
              </el-form-item>
              <el-form-item label="活动时间:">
                <div class="activity-datetime line">
                  {{ $moment(activity.starttime).format("MM/DD HH:mm") }}
                  ~ {{ $moment(activity.endtime).format("MM/DD HH:mm") }}
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="footer">
            <el-row class="footer-content">
              <el-col :span="12" class="action">
                <div class="btn-wrapper">
                  <el-button
                    link type="primary"
                    class="btn"
                    @click="handleEdit(activity)"
                    >编辑</el-button
                  >
                </div>
                <div class="split"></div>
              </el-col>
              <el-col :span="12" class="action">
                <div class="btn-wrapper">
                  <el-button link type="primary" class="btn">
                    <a
                      :href="redirectBase + activity.activityid"
                      target="_blank"
                      >分享</a
                    ></el-button
                  >
                </div>
                <!-- <div class="split"></div> -->
              </el-col>
              <!-- <el-col :span="8" class="action">
                  <div class="btn-wrapper">
                    <el-button link type="primary" class="btn" @click="handleAnalysis(activity)">统计</el-button>
                  </div>
                </el-col> -->
            </el-row>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8" :xl="6">
        <el-card class="activity-card" shadow="hover">
          <router-link
            :to="{
              name: 'ProjectActivities',
              query: { action: 'new', project: currentProjectId },
            }"
            style="font-size: 25px; font-weight: bold; color: #bbb"
          >
            <div style="padding: 80px 20px; text-align: center">+ 创建活动</div>
          </router-link>
        </el-card>
      </el-col>
    </el-row>
    <el-row v-if="showLoadMore && !isLoading">
      <el-col style="text-align: center">
        <el-button plain style="width: 100%" @click="getActivityList(false)"
          >加&nbsp;载&nbsp;更&nbsp;多</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { getCurrentInstance, onMounted, reactive, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";
import { useProjectStore } from "@/Store/ProjectStore";
import { apiGetActivityList } from "@/Api/AppApi";

const router = useRouter();
const projectStore = useProjectStore();
const { currentProjectId } = storeToRefs(projectStore);

const { appContext } = getCurrentInstance();
const $message = appContext.config.globalProperties.$message;
const $moment = appContext.config.globalProperties.$moment;

const redirectBase = router.resolve("/activity/").href;

onMounted(() => {
  if (currentProjectId.value) {
    getActivityList(true);
  }
});
watch(currentProjectId, (val) => {
  if (val) {
    getActivityList(true);
  }
});

const statusEnum = {
  draft: 0,
  published: 1,
  closed: 2,
  pending: 3,
  opening: 4,
  over: 5,
};
const statusCNEnum = {
  0: "草稿",
  1: "已发布",
  2: "已关闭",
  3: "未开始",
  4: "进行中",
  5: "已结束",
};
const statusClassEnum = {
  0: "status-blue",
  1: "status-default",
  2: "status-default",
  3: "status-blue",
  4: "status-green",
  5: "status-default",
};
const options = [statusEnum.draft, statusEnum.published, statusEnum.over];

const selectedStatus = ref(statusEnum.published);
const isLoading = ref(false);
const page = reactive({
  total: 0,
  cursor: 0, // 加载数据的起始下标
  count: 10, // 每次加载的数据量
});
const activities = ref([]);
const showLoadMore = ref(false);
async function getActivityList(isFirst) {
  if (isFirst) {
    activities.value = [];
    page.total = 0;
    page.cursor = 0;
  }
  const params = {
    cursor: page.cursor,
    count: page.count,
    status: selectedStatus.value,
  };
  isLoading.value = true;
  const res = await apiGetActivityList(currentProjectId.value, params);
  isLoading.value = false;
  if (res.code === 0) {
    const newActivities = res.data.data || [];

    // 因为后端返回的 page.total 可能会多,所以这里处理一下让体验更友好
    if (newActivities.length == 0 && !isFirst) {
      $message.success("没有更多数据了哦~");
    }

    activities.value = activities.value.concat(newActivities);
    page.total = res.data.page.total;
    page.cursor = res.data.page.next;
    showLoadMore.value =
      newActivities.length > 0 && page.total - 1 > activities.value.length;
  } else {
    $message.error(res.message);
  }
}

function handleEdit(acitvity) {
  router.push({
    name: "ProjectActivities",
    query: {
      action: "edit",
      project: currentProjectId.value,
      id: acitvity.activityid,
    },
  });
}
</script>

<style lang="scss" scoped>
.project-activities-root {
  padding: 20px 20px 0;
}
.activity-card {
  height: 230px;
  margin-bottom: 20px;
  position: relative;
}

.activity-card .el-form-item {
  margin-bottom: 0px;
}

.activity-card .content {
  padding: 20px;
}

.activity-card .activity-title {
  font-size: 18px;
  margin-bottom: 20px;
  font-weight: bold;
  display: inline-block;
  max-width: 80%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.activity-card .line {
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.activity-card .activity-status {
  display: inline-block;
  position: absolute;
  top: 0px;
  right: 20px;
  text-align: center;
  padding: 5px 0px;
  font-size: 14px;
  min-width: 60px;
  color: #fff;
}

.activity-card .status-blue {
  /*background-color: #409EFF;*/
  background-color: #1f86e4;
}

.activity-card .status-green {
  background-color: #35c683;
}

.activity-card .status-default {
  /*background-color: #E4E7ED;*/
  background-color: #dddddd;
}

.activity-card .footer {
  background-color: #f5f5f5;
  line-height: 50px;
}

.activity-card .footer-content {
  width: 300px;
  margin: auto;
}

.activity-card .footer .action {
  text-align: right;
}

.activity-card .footer .btn-wrapper {
  display: inline-block;
  text-align: center;
  width: 94%;
  margin: auto;
}

.activity-card .footer .btn {
  color: #909399;
}

.activity-card .footer .split {
  display: inline-block;
  height: 18px;
  border-right: solid 1px #ccc;
  position: relative;
  top: 5px;
}

.container {
  max-height: calc(100vh - 132px);
  overflow: auto;
}
</style>
